import Vue from 'vue';
import VueAwesomeSwiper from 'vue-awesome-swiper';

// require styles
import 'swiper/dist/css/swiper.css';
import './swiper.less';

Vue.use(VueAwesomeSwiper /* { default global options } */);
